var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactsOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.92 11.84c-2.15 0-3.9-1.75-3.9-3.9s1.75-3.9 3.9-3.9 3.9 1.75 3.9 3.9c0 2.15-1.75 3.9-3.9 3.9zM7.92 5.24c-1.489 0-2.7 1.211-2.7 2.7s1.211 2.7 2.7 2.7c1.489 0 2.7-1.211 2.7-2.7s-1.211-2.7-2.7-2.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.32 18.44c-0.331 0-0.6-0.269-0.6-0.6 0-2.646-2.154-4.8-4.8-4.8s-4.8 2.154-4.8 4.8c0 0.331-0.269 0.6-0.6 0.6s-0.6-0.269-0.6-0.6c0-3.308 2.692-6 6-6s6 2.692 6 6c0 0.331-0.269 0.6-0.6 0.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.102 13.040c-1.819 0-3.3-1.481-3.3-3.3s1.481-3.3 3.3-3.3 3.3 1.48 3.3 3.3c0 1.819-1.481 3.3-3.3 3.3zM16.102 7.64c-1.158 0-2.1 0.942-2.1 2.1s0.942 2.1 2.1 2.1c1.158 0 2.1-0.942 2.1-2.1s-0.942-2.1-2.1-2.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.52 18.44c-0.331 0-0.6-0.269-0.6-0.6 0-0.451-0.079-0.895-0.236-1.318-0.353-0.958-1.058-1.721-1.985-2.148-0.508-0.234-1.046-0.354-1.598-0.354-0.45 0-0.895 0.080-1.325 0.238-0.066 0.025-0.136 0.037-0.207 0.037-0.25 0-0.476-0.158-0.563-0.392-0.055-0.15-0.050-0.314 0.018-0.458s0.187-0.257 0.338-0.312c0.558-0.206 1.141-0.31 1.732-0.31 2.097 0 3.991 1.32 4.715 3.285 0.206 0.557 0.311 1.14 0.311 1.734 0 0.33-0.269 0.6-0.6 0.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactsOutline);
export default __webpack_public_path__ + "static/media/ContactsOutline.57007b780d7c4e63a533fd13886c7808.svg";
export { ForwardRef as ReactComponent };